<template>
  <div id="cesium-container" ref="cesiumContainer">
    <cesium-recorder ref="cesiumRecorder" />
  </div>
</template>

<script>
import { CesiumInitialization } from '../../components/ThreeD/CesiumInitialization'
import { PointOfInterest } from '../../components/ThreeD/PointOfInterest'
import { ZoneOfInterest } from '../../components/ThreeD/ZoneOfInterest'
import { EarthMesh } from '../../components/ThreeD/EarthMesh'
import CesiumRecorder from '../../components/ThreeD/CesiumRecorder.vue'

export default {
  name: 'ZOI-cesium-viewer',
  mixins: [CesiumInitialization, ZoneOfInterest, PointOfInterest, EarthMesh],
  props: ['poi', 'meshes', 'points'],
  components: {
    'cesium-recorder': CesiumRecorder
  },
  watch: {
    poi: {
      handler() {
        this.onPoiListChange(this.poi)
      },
      deep: true
    },
    points() {
      this.onMeshesListChange(this.meshes, this.points)
    }
  },

  mounted() {
    this.initializeViewer()
    this.insertElementInToolbar(this.$refs.cesiumRecorder.$el)
    this.deactivateControls()
    this.initMeshesPC()
    this.initPOIDataSource()
    this.onPoiListChange(this.poi)
    this.onMeshesListChange(this.meshes)
  }
}
</script>

<style scoped>
#cesium-container {
  position: relative;
  height: 500px;
  width: 100%;
  z-index: 999;
}
</style>
